import { html, View } from 'rune-ts';
import klass from './CountViewView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';

type TProps = {
  size: 'Medium' | 'Small';
  watcher_count: number;
};

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=26351-74974&m=dev
 */
export class CountViewView extends View<TProps> {
  protected override template({ size, watcher_count }: TProps) {
    return html`<span
      class="${classes(klass.count_view, font(size === 'Medium' ? '12_medium' : '10_medium'))}"
    >
      ${ET('card_product::count_view::watching', { watcher_count })}
    </span>`;
  }
}
